module.exports = __webpack_public_path__ + "static/media/direct_messaging.4ce9e8d6.svg";